export default "__VITE_ASSET__BD7zpdgh__"